module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    domProps: {
      "innerHTML": _vm._s(_vm.headingtext)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row no-margin flex-horizontal-align-center"
  }, _vm._l((_vm.elements), function(element, index) {
    return _c('div', {
      key: index,
      staticClass: "row-element col-l-3 col-m-3 col-s-12"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "top"
    }, [(!element.top_image) ? _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(element.top_text))]) : _vm._e(), _vm._v(" "), (element.top_image) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": element.top_image.url,
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bottom",
      domProps: {
        "innerHTML": _vm._s(element.text)
      }
    })])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-253005a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseFooter.vue
// module id = 322
// module chunks = 0